
import React from 'react';
import { Link } from 'react-router-dom';
import { PRODUCTS } from '../constants';
import ProductCard from '../components/ProductCard';

const Home: React.FC = () => {
  const FEATURED_IDS = ['m3min_sud_no_cap', 'r26_cami', 'j25_taza', 'mazdalm_botella'];
  const featured = FEATURED_IDS
    .map(id => PRODUCTS.find(p => p.id === id))
    .filter((p): p is NonNullable<typeof p> => Boolean(p));

  return (
    <div className="flex flex-col items-center w-full">
      {/* Hero Section */}
      <section className="w-full px-4 md:px-10 pt-8 pb-4 max-w-[1400px]">
        <div 
          className="relative w-full rounded-2xl md:rounded-3xl overflow-hidden h-[550px] md:h-[700px] bg-cover bg-center flex items-center justify-center group" 
          style={{ 
            backgroundImage: "linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.7)), url('person_foto.png')"
          }}
        >
          <div className="relative z-10 text-center flex flex-col items-center gap-6 md:gap-8 max-w-4xl px-6">
            <div className="flex items-center gap-3 bg-white/10 backdrop-blur-md px-3 py-1.5 rounded-full border border-white/20">
              <span className="size-1.5 bg-red-600 rounded-full animate-pulse"></span>
              <span className="text-white font-bold tracking-[0.2em] md:tracking-[0.3em] text-[8px] md:text-[10px] uppercase">Personalización • Disponible Ahora</span>
            </div>
            <h1 className="text-white text-5xl sm:text-7xl md:text-8xl lg:text-[10rem] font-black tracking-tighter uppercase leading-[0.9] md:leading-[0.8] drop-shadow-2xl">
              PERSONALIZA<br/><span className="text-primary italic">con tu coche</span>
            </h1>
            <p className="text-gray-200 text-sm md:text-2xl font-light max-w-xl mt-2 md:mt-4 leading-relaxed">
              Personaliza ya cualquier prenda con tu coche!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mt-4 w-fit">
              <Link to="/custom" className="bg-primary hover:bg-blue-700 text-white px-8 md:px-12 py-4 md:py-5 rounded-xl font-black tracking-widest transition-all transform hover:scale-105 shadow-2xl shadow-primary/40 uppercase italic text-xs md:text-base">
                Personalizar Ahora
              </Link>
            </div>
          </div>
        </div>
      </section>

{/* Banner Envío Gratis - Minimal */}
<section className="w-full bg-black py-3 px-4 md:px-10">
  <div className="max-w-[1400px] mx-auto text-center">
    <p className="text-white text-base md:text-lg font-bold uppercase tracking-widest italic">
      🚚 Envío GRATIS en pedidos a partir de 65€
    </p>
  </div>
</section>

      {/* Featured Products */}
      <section className="w-full max-w-[1400px] px-4 md:px-10 py-24">
        <div className="flex items-end justify-between mb-12 border-b border-gray-100 pb-8">
          <div>
            <h2 className="text-black text-4xl md:text-5xl font-black uppercase tracking-tighter italic">Destacados</h2>
          </div>
          <Link to="/shop" className="hidden md:flex items-center gap-2 text-sm font-black uppercase tracking-widest group">
            Ver Todo <span className="material-symbols-outlined transition-transform group-hover:translate-x-1">arrow_forward</span>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {featured.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </section>

      {/* Technical Briefing */}
      <section className="w-full bg-black py-32 px-4 md:px-10">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          <div className="relative aspect-square rounded-3xl overflow-hidden grayscale">
             <img src="/original.png" className="w-full h-full object-cover" alt="Tejido Técnico" />
             <div className="absolute inset-0 bg-primary/20 mix-blend-overlay"></div>
          </div>
          <div className="space-y-10">
            <div>
              <h2 className="text-white text-5xl md:text-6xl font-black uppercase italic leading-none mt-4">Hecho por nosotros,  <br/> pensado para ti.</h2>
            </div>
            <div className="space-y-8">
              <div className="flex gap-6">
                <div className="size-14 rounded-2xl bg-white/5 flex items-center justify-center shrink-0 border border-white/10">
                  <span className="material-symbols-outlined text-primary text-3xl">design_services</span>
                </div>
                <div>
                  <h4 className="text-white font-bold uppercase text-lg mb-2 italic">Diseños 100% originales</h4>
                  <p className="text-gray-400 text-sm leading-relaxed">Cada prenda está diseñada por nosotros y fabricada a mano, creando piezas exclusivas que no encontrarás en ningún otro lugar.</p>
                </div>
              </div>
              <div className="flex gap-6">
                <div className="size-14 rounded-2xl bg-white/5 flex items-center justify-center shrink-0 border border-white/10">
                  <span className="material-symbols-outlined text-primary text-3xl">shield</span>
                </div>
                <div>
                  <h4 className="text-white font-bold uppercase text-lg mb-2 italic">Estilo y calidad que perduran</h4>
                  <p className="text-gray-500 text-sm leading-relaxed">Materiales premium y acabados cuidados para que cada sudadera, camiseta o accesorio mantenga su forma y estilo, día tras día.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
